<template lang="pug">
Paginator.rounded-lg(
  v-model:first="offset"
  :rows="props.perPage"
  :totalRecords="props.totalCount"
  @page="onPaginate"
  :alwaysShow="true"
)
  template(#container="{ first, last, page, pageCount, prevPageCallback, nextPageCallback, totalRecords }")
    .flex.items-center.gap-4.rounded-full.justify-between
      Button(
        icon="ph ph-arrow-left"
        severity="secondary" rounded
        @click="prevPageCallback"
        :disabled="page === 0")

      div
        span(class="hidden sm:block") 
          span {{ first }} - {{ last }} 
          span.text-canvas-400.ml-1 of {{ totalRecords }}
        span(class="block sm:hidden") Page {{ page + 1 }} of {{ pageCount }}
      
      Button(
        icon="ph ph-arrow-right"
        severity="secondary" rounded
        @click="nextPageCallback"
        :disabled="page === pageCount - 1")
</template>

<script setup>
import { ref, watchEffect } from 'vue'
import Paginator from 'primevue/paginator';

const props = defineProps({
  page: { type: Number, required: false, default: 1 },
  perPage: { type: Number, required: true, default: 20 },
  totalCount: { type: Number, required: true, default: 0 },
  showPageReport: { type: Boolean, default: false },
})

const emit = defineEmits({
  changePage: ({currentPage}) => {
    // console.log('emit: changePage', currentPage)
    return Number.isInteger(currentPage)
  }
})

const offset = ref(0);
const currentPage = ref(1);

const first = ref(1)
const last  = ref()

watchEffect(() => {
  offset.value = (props.perPage * (props.page - 1))
  currentPage.value = props.page;
  if (props.totalCount < props.perPage) {
    first.value = 1
    last.value  = props.totalCount
  } else {
    first.value =  ((props.page - 1) * props.perPage) + 1
    last.value  = props.perPage * props.page   
  }
})

const onPaginate = (e) => {
  currentPage.value = +e.page + 1
  emit('changePage', {currentPage: currentPage.value})
}
</script>